var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h4',{staticClass:"section-title"},[_vm._v(" "+_vm._s(_vm.title)+" "),(!_vm.isLoading)?_c('label',[_c('input',{attrs:{"name":"status","type":"checkbox"},domProps:{"checked":_vm.value},on:{"input":function($event){return _vm.$emit('input', !_vm.value)}}}),_vm._v(" Active ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }